exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spot-details {\n  position: absolute;\n  top: 0;\n  left: 0;\n  max-width: 100%;\n  max-height: 100%;\n  height: 100%;\n  width: 100%;\n  border-radius: 0;\n  margin: 0;\n  background-color: #fff;\n}\n.spot-details .content {\n  padding: 40px;\n}\n:host /deep/ .description img {\n  height: 100px !important;\n  clear: both !important;\n  display: block !important;\n}\n.close,\n.mat-chip {\n  float: right;\n  cursor: pointer !important;\n}\n.description {\n  margin-top: 20px;\n  max-width: 600px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/spot-details/spot-details.component.less
// module id = 388
// module chunks = 1